import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * @deprecated Remove directive when the new cv click outside directive replaces `appMouseDownOutside` in dashboard actions,
 * and dashboard action filter settings.
 */
@Directive({
    selector: '[appMouseDownOutside]',
    standalone: false
})
export class MouseDownOutsideDirective {
  @Output() appMouseDownOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef<HTMLDivElement>) {}
  @HostListener('document:mousedown', ['$event.target'])
  public onClick(target: Node) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.appMouseDownOutside.emit();
    }
  }

  // this should have own directive. this is not related to click outside functionality
  @HostListener('document:keydown.escape', ['$event']) onKeydown() {
    this.appMouseDownOutside.emit();
  }
}
